exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Popup-module__popup___3J8SZ{position:absolute;right:85px;top:0;border-radius:15px;color:#181818;padding:1em;background-color:#fff;box-shadow:0 0 3px 0 rgba(0,0,0,.1)}@media screen and (max-height:1100px){.Popup-module__popup___3J8SZ{max-height:calc(var(--app-height)*0.9);overflow:auto;-webkit-overflow-scrolling:touch}}", ""]);

// exports
exports.locals = {
	"popup": "Popup-module__popup___3J8SZ"
};